<template>
  <div class="new-leave" v-if="initData.period_times">
    <!-- 请假学生 -->
    <div class="form-section mt0">
      <div class="section-header">
        <span class="required-label">{{ $t("leave.leave_student") }} <span class="required">*</span></span>
        <span class="selected-count" v-if="studentList.length > 1">{{ $t("leave.selected") }}: {{ selectedStudents.length }}</span>
      </div>
      <div class="student-select-list">
        <div class="student-select-item" v-for="student in studentList" :key="student.child_id" @click="studentList.length > 1 && toggleStudent(student)">
          <img :src="student.child_avatar" class="student-avatar-sm" />
          <div class="student-info">
            <div class="student-name-sm">{{ student.child_name }}</div>
            <div class="student-class-sm">{{ student.class_title }}</div>
          </div>
          <div class="radio-btn" :class="{ checked: isSelected(student) }" v-if="studentList.length > 1">
            <van-icon v-if="isSelected(student)" name="success" color="#fff" size="14" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedStudents.length > 0">
      <!-- 请假类型 -->
      <div class="form-section">
        <div class="section-header">
          <span class="required-label">{{ $t("leave.leave_type") }} <span class="required">*</span></span>
        </div>
        <div class="type-tabs">
          <div class="type-tab" v-for="type in typeTabs" :key="type.value" :class="{ active: leaveForm.type === type.value }" @click="leaveForm.type = type.value">{{ type.label }}</div>
        </div>
      </div>
      <!-- 面包屑 -->
      <!-- <van-notice-bar color="#1989fa" wrapable  :scrollable="false" background="#E8F3FF" left-icon="info-o"> {{ $t("leave.not_bus") }}</van-notice-bar> -->
      <!-- 日期选择 -->
      <div class="form-section">
        <div class="section-header">
          <span class="required-label">{{ $t("leave.date") }} <span class="required">*</span></span>
          <!-- <span class="calendar-link" @click="showSchedulePopup = true" v-if="Object.keys(initData.period_times).length > 0">
          <van-icon name="clock-o" size="18" />
          中学上课时间表
        </span> -->
        </div>

        <!-- v-calendar -->
        <div class="calendar-wrapper" ref="calendarWrapper">
          <v-calendar :locale="localeType" color="#1989fa" :attributes="calendarAttrs" :min-date="minDate" style="width: 100%" @dayclick="onDayClick" />
        </div>
        <!-- 已选日期列表 -->
        <div class="selected-dates">
          <div class="selected-date-item" v-for="(dateEntry, idx) in leaveForm.dateEntries" :key="idx">
            <div class="date-item-header">
              <span class="date-item-title">{{ dateEntry.date }} {{ dateEntry.weekday }}</span>
              <van-icon name="delete-o" color="#666" size="18" @click="removeDateEntry(idx)" />
            </div>
            <van-divider />
            <div class="flex">
              <div class="color6 mb-5">{{ $t("leave.period") }} <span class="required">*</span></div>
              <div class="flex1">
                <div class="time-ranges" v-if="dateEntry.day.length == 0">
                  <div class="time-range-row" @click="editDateEntryTime(idx)">
                    <span class="time-range-label colorC">{{ $t("leave.please_select") }}</span>
                  </div>
                  <van-icon name="arrow" color="#C8C9CC" class="arrow-icon" />
                </div>
                <div class="time-ranges" v-if="dateEntry.day.length != 0">
                  <div class="time-range-row" @click="editDateEntryTime(idx)">
                    <div class="time-range-label period" v-for="(tr, tIdx) in dateEntry.day" :key="tIdx">
                      <!-- <div class='color6 mb-5' v-if='tIdx == 0'>{{ $t("leave.period") }} <span class="required">*</span></div> -->
                      <div v-if="tr.day_type == 10">{{ $t("leave.full_day") }}</div>
                      <div v-if="tr.day_type == 20">{{ $t("leave.late", { t: tr.day_time }) }}</div>
                      <div v-if="tr.day_type == 30">{{ $t("leave.early", { t: tr.day_time }) }}</div>
                      <div v-if="tr.day_type == 40">{{ $t("leave.custom_time", { t: tr.day_time }) }}</div>
                    </div>
                  </div>
                  <van-icon name="arrow" class="arrow-icon" color="#C8C9CC" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 请假原因 -->
      <div class="form-section">
        <div class="section-header">
          <span class="required-label">{{ $t("leave.reason") }} <span class="required">*</span></span>
        </div>
        <textarea class="reason-input" v-model="leaveForm.reason" :placeholder="$t('leave.reason_placeholder')" rows="4"></textarea>
      </div>

      <!-- 附件 -->
      <div class="form-section">
        <div class="section-header">
          <span class="label-text">{{ $t("leave.attachment") }}</span>
        </div>
        <div class="attachment-area">
          <van-uploader v-model="attachments" :max-size="1024 * 1024 * 50" @oversize="onOversize" :after-read="afterRead" :max-count="9" multiple @delete="onDeleteFile" />
        </div>
      </div>

      <!-- 底部提交按钮 -->
      <div class="bottom-btn">
        <div class="btn-submit" @click="verification()">{{ $t("leave.submit") }}</div>
      </div>
    </div>
    <!-- 选择时间弹窗 -->
    <van-popup v-model="showTimePopup" position="bottom" round :style="{ maxHeight: '80vh' }" class="time-popup-popup">
      <div class="time-popup">
        <div class="popup-header">
          <span class="popup-title">{{ $t("leave.select_time") }}</span>
          <!-- <van-icon name="cross" @click="showTimePopup = false" /> -->
        </div>

        <div class="time-popup-body">
          <!-- 全天/非全天 -->
          <div class="time-type-row">
            <div class="radio-item" @click="timeForm.isFullDay = true" v-if="isCurrentDate()">
              <div class="radio-circle" :class="{ checked: timeForm.isFullDay }">
                <van-icon v-if="timeForm.isFullDay" name="success" color="#fff" size="12" />
              </div>
              <span>{{ $t("leave.full_day") }}</span>
            </div>
            <div class="radio-item" @click="timeForm.isFullDay = false">
              <div class="radio-circle" :class="{ checked: !timeForm.isFullDay }">
                <van-icon v-if="!timeForm.isFullDay" name="success" color="#fff" size="12" />
              </div>
              <span>{{ $t("leave.partial_day") }}</span>
            </div>
          </div>

          <!-- 非全天选项 -->
          <div v-if="!timeForm.isFullDay" class="partial-options">
            <!-- 晚到 -->
            <div v-if="isCurrentDate()" class="option-row late-time-row" :class="{ expanded: timeForm.late, 'option-active': timeForm.latePickerValue }">
              <div class="option-header" @click="toggleExpand('late')">
                <span class="option-label">{{ $t("leave.lateValue") }}</span>
                <div class="option-value" v-if="timeForm.latePickerValue">
                  <span>{{ $t("leave.late_end", { t: timeForm.latePickerValue }) }}</span>
                  <van-icon name="clear" size="16" @click.stop="clearLateTime" />
                </div>
                <div class="option-placeholder" v-else>
                  <span>{{ $t("leave.not_selected") }}</span>
                </div>
                <van-icon name="arrow-down" color="#C8C9CC" class="ml-8" :class="{ 'is-expanded': timeForm.late }" />
              </div>
              <!-- 晚到时间选择器 -->
              <div class="inline-time-picker" v-if="timeForm.late">
                <van-datetime-picker item-height="40" visible-item-count="5" :min-hour="minHour" :max-hour="maxHour" v-model="timeForm.latePickerValue" type="time" :title="$t('leave.select_time')" class="inline-picker" :filter="filter" />
              </div>
            </div>
            <!-- 早退 -->
            <div class="option-row early-time-row" :class="{ expanded: timeForm.early, 'option-active': timeForm.earlyPickerValue }">
              <div class="option-header" @click="toggleExpand('early')">
                <span class="option-label">{{ $t("leave.earlyValue") }}</span>
                <div class="option-value" v-if="timeForm.earlyPickerValue">
                  <span>{{ $t("leave.early_end", { t: timeForm.earlyPickerValue }) }}</span>
                  <van-icon name="clear" size="16" @click.stop="clearEarlyTime" />
                </div>
                <div class="option-placeholder" v-else>
                  <span>{{ $t("leave.not_selected") }}</span>
                  <!-- <van-icon name="clear" size="16" v-if="timeForm.early" @click.stop="timeForm.early = false" /> -->
                </div>
                <van-icon name="arrow-down" color="#C8C9CC" class="ml-8" :class="{ 'is-expanded': timeForm.early }" />
              </div>
              <!-- 早退时间选择器 -->
              <div class="inline-time-picker" v-if="timeForm.early">
                <van-datetime-picker item-height="40" visible-item-count="5" :min-hour="todayMinHour" :min-minute="todayMinMinute(timeForm.earlyPickerValue)" :max-hour="maxHour" v-model="timeForm.earlyPickerValue" type="time" :title="$t('leave.select_time')" class="inline-picker" :filter="filter" />
              </div>
            </div>
            <!-- 自定义时间段 -->
            <div class="option-row custom-time-row" :class="{ expanded: timeForm.customTime, 'option-active': timeForm.customStart && timeForm.customEnd }">
              <div class="option-header" @click="toggleExpand('customTime')">
                <span class="option-label">{{ $t("leave.custom_timeValue") }}</span>
                <div class="option-value" v-if="timeForm.customStart && timeForm.customEnd">
                  <span>{{ timeForm.customStart + " - " + timeForm.customEnd }}</span>
                  <van-icon name="clear" size="16" @click.stop="clearCustomTime" />
                </div>
                <div class="option-placeholder" v-else>
                  <span>{{ $t("leave.please_select") }}</span>
                  <van-icon name="clear" size="16" v-if="timeForm.customTime" @click.stop="timeForm.customTime = false" />
                </div>
                <van-icon name="arrow-down" color="#C8C9CC" class="ml-8" :class="{ 'is-expanded': timeForm.customTime }" />
              </div>
              <!-- 自定义时间段选择器 -->
              <div class="custom-time-picker" v-if="timeForm.customTime">
                <div class="custom-time-display-row">
                  <div class="custom-time-box" :class="timeType == 1 ? 'start' : ''" @click="showDatetime(1)">
                    <span class="time-text" v-if="timeForm.customStart">{{ timeForm.customStart }}</span>
                    <span class="time-text placeholder" v-else>{{ $t("leave.start_time") }}</span>
                  </div>
                  <span class="time-separator">-</span>
                  <div class="custom-time-box" :class="timeType == 2 ? 'start' : ''" @click="showDatetime(2)">
                    <span class="time-text" v-if="timeForm.customEnd">{{ timeForm.customEnd }}</span>
                    <span class="time-text placeholder" v-else>{{ $t("leave.end_time") }}</span>
                  </div>
                </div>
                <div class="time-picker-wrapper" v-if="datetimePicker">
                  <van-datetime-picker item-height="40" visible-item-count="5" v-model="timeForm.customPickerValues" type="time" :title="$t('leave.select_time')" :min-hour="todayMinHour" :min-minute="todayMinMinute(timeForm.customPickerValues)" :max-hour="maxHour" @change="onCustomTimeChange" class="inline-picker" :filter="filter" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="popup-actions">
          <div class="btn-cancel" @click="showTimePopup = false">{{ $t("global.cancel") }}</div>
          <div class="btn-confirm" @click="confirmTime">{{ $t("global.ok") }}</div>
        </div>
      </div>
    </van-popup>

    <!-- 中学上课时间表弹窗 -->
    <van-popup v-model="showSchedulePopup" position="bottom" round>
      <div class="schedule-popup">
        <div class="popup-header">
          <span class="popup-title">{{ $t("leave.school_schedule") }}</span>
          <van-icon name="cross" @click="showSchedulePopup = false" />
        </div>
        <div class="schedule-list">
          <div class="schedule-item" v-for="(item, key, i) in initData.period_times" :key="i">
            <span class="schedule-id">#{{ key }}</span>
            <span class="schedule-time">{{ item }}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 确认请假信息弹窗 -->
    <van-popup v-model="showConfirmPopup" position="bottom" round :style="{ maxHeight: '80vh' }">
      <div class="confirm-popup">
        <div class="popup-header">
          <span class="popup-title">{{ $t("leave.confirm_info") }}</span>
          <van-icon name="cross" @click="showConfirmPopup = false" />
        </div>
        <div class="confirm-content">
          <div>
            <span class="font14 color6">{{ $t("leave.leave_student") }}</span>
            <div class="confirm-students">
              <div class="confirm-student" v-for="sid in selectedStudents" :key="sid">
                <img :src="getStudentById(sid).child_avatar" class="confirm-avatar" />
                <div>
                  <div class="confirm-name">{{ getStudentById(sid).child_name }}</div>
                  <div class="confirm-class">{{ getStudentById(sid).class_title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="confirm-row">
            <span class="confirm-label">{{ $t("leave.leave_type") }}</span>
            <span class="confirm-value">{{ getType(leaveForm.type) }}</span>
          </div>
          <div class="confirm-row">
            <span class="confirm-label">{{ $t("leave.date") }}</span>
            <div class="confirm-dates">
              <div class="confirm-date-item" v-for="(entry, idx) in leaveForm.dateEntries" :key="idx">
                <div class="confirm-date-title">{{ entry.date }} {{ entry.weekday }}</div>
                <div class="confirm-date-times">
                  <div class="time-ranges" v-if="entry.day.length != 0">
                    <div class="time-range-row">
                      <span class="time-range-label" v-for="(tr, tIdx) in entry.day" :key="tIdx">
                        <span v-if="tr.day_type == 10">{{ $t("leave.full_day") }}</span>
                        <span v-if="tr.day_type == 20">{{ $t("leave.late", { t: tr.day_time }) }}</span>
                        <span v-if="tr.day_type == 30">{{ $t("leave.early", { t: tr.day_time }) }}</span>
                        <span v-if="tr.day_type == 40">{{ $t("leave.custom_time", { t: tr.day_time }) }}</span>
                        <span v-if="tIdx < entry.day.length - 1">、</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="confirm-row">
            <span class="confirm-label">{{ $t("leave.reason") }}</span>
            <span class="confirm-value confirm-reason" v-html="htmlBr(leaveForm.reason)"></span>
          </div>
          <div class="confirm-row" v-if="leaveForm.attachments.length > 0">
            <span class="confirm-label">{{ $t("leave.attachment") }}</span>
            <div class="confirm-attachments">
              <img v-for="(img, idx) in leaveForm.attachments" :key="idx" :src="img.url" class="confirm-attachment-img" />
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <div class="btn-cancel" @click="showConfirmPopup = false">{{ $t("global.cancel") }}</div>
          <div class="btn-confirm" :class="{ 'is-disabled': isSubmitting }" @click="submitLeave">{{ $t("global.submit") }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Popup, Toast, Picker, Divider, DatetimePicker, Uploader } from "vant";
import VCalendar from "v-calendar";
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Divider);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(VCalendar);
import { formInit, qiniuToken, createLeave } from "@/api/leave";
import storage from "store";
import * as qiniu from "qiniu-js";
import { APP_LANGUAGE } from "@/store/mutation-types";
import router from "../router";
export default {
  name: "StudentLeaveNew",
  data() {
    return {
      minHour: 7,
      maxHour: 16,
      showTimePopup: false,
      showSchedulePopup: false,
      showConfirmPopup: false,
      localeType: "zh-cn",
      studentList: [],
      selectedStudents: [],
      typeTabs: [],
      leaveForm: {
        type: "",
        reason: "",
        attachments: [],
        dateEntries: [],
      },
      selectedDates: [],
      minDate: new Date(new Date().setHours(0, 0, 0, 0)),
      addAttrsLeave: [],
      currentClickDate: null,
      timeForm: {
        isFullDay: true,
        late: false,
        latePickerValue: "",
        early: false,
        earlyPickerValue: "",
        customTime: false,
        customStart: "",
        customEnd: "",
        customPickerValues: "",
      },
      initData: {},
      weekDays: [this.$t("leave.Sun"), this.$t("leave.Mon"), this.$t("leave.Tue"), this.$t("leave.Wed"), this.$t("leave.Thu"), this.$t("leave.Fri"), this.$t("leave.Sat")],
      datetimePicker: false,
      timeType: "",
      day_types: {},
      token: "",
      attachments: [],
      isSubmitting: false,
      offDate: "09:30",
      currentTime: "",
      currentDate: "",
    };
  },
  computed: {
    // 当前正在编辑的日期是否为当天（currentDate 会在打开时间选择器时刷新）
    isToday() {
      return !!this.currentDate && this.currentClickDate === this.currentDate;
    },
    // 当前时间的小时（取自 currentTime，保证刷新时间后随之更新）
    currentHour() {
      return this.currentTime ? Number(String(this.currentTime).split(":")[0]) : null;
    },
    // 当前时间的分钟
    currentMinute() {
      return this.currentTime ? Number(String(this.currentTime).split(":")[1]) : null;
    },
    // 当前时间的分钟边界（向上取整到 5 的整数倍）：当前 10:51 时为 55；56~59 分时为 60（表示当前小时已无可用分钟）
    currentMinuteBoundary() {
      return Math.ceil((this.currentMinute || 0) / 5) * 5;
    },
    // 最小可选小时：所选日期是当天时限制为当前小时，其他日期沿用 minHour
    todayMinHour() {
      if (!this.isToday || this.currentHour === null) return this.minHour;
      // 当前小时已无可用分钟（如 10:58）时，最早可选时间为下一个整点
      const hour = this.currentMinuteBoundary >= 60 ? this.currentHour + 1 : this.currentHour;
      return Math.min(this.maxHour, Math.max(this.minHour, hour));
    },
    calendarAttrs() {
      return [
        {
          // 周六、周日禁用（灰色 + 不可点击）
          dates: (date) => {
            const d = date instanceof Date ? date : new Date(date.year, date.month - 1, date.day);
            return d.getDay() === 0 || d.getDay() === 6;
          },
          disabled: true,
        },
        ...this.addAttrsLeave,
      ];
    },
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f7f8fa");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  created() {
    let cuLang = storage.get(APP_LANGUAGE) || "zh";
    this.localeType = cuLang == "zh" ? "zh-cn" : "en-us";
    formInit().then((res) => {
      if (res.code == 0) {
        this.initData = res.data;
        this.studentList = res.data.children;
        if (this.studentList.length == 1) {
          this.selectedStudents = [this.studentList[0].child_id];
        }
        this.typeTabs = res.data.leave_types;
        this.day_types = res.data.day_types;
      }
    });
    qiniuToken({ school_id: "BJ_DS" }).then((res) => {
      if (res.code == 0) {
        this.token = res.data.token;
      }
    });
  },
  methods: {
    filter(type, options) {
      if (type === "minute") {
        return options.filter((option) => option % 5 === 0);
      }
      return options;
    },
    // 最小可选分钟：所选日期是当天、且选中小时为当前小时时，取当前分钟向上取整到 5 的整数倍（当前 10:51 → 最小 55）
    todayMinMinute(timeStr) {
      if (!this.isToday || this.currentHour === null) return 0;
      // 当前小时已无可用分钟（56~59 分），最小分钟从整点开始（配合 todayMinHour 已把最小小时推到下一小时）
      if (this.currentMinuteBoundary >= 60) return 0;
      // 未选中小时（选择器刚打开、v-model 为空）时按当前小时处理，避免默认落到已经过去的分钟
      const hour = timeStr ? Number(String(timeStr).split(":")[0]) : this.currentHour;
      if (hour !== this.currentHour) return 0;
      return this.currentMinuteBoundary;
    },
    // 重新获取当前时间
    refreshCurrentTime() {
      const now = new Date();
      this.currentTime = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      this.currentDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    },
    timeToMinutes(timeStr) {
      const match = String(timeStr || "").match(/(\d{1,2}):(\d{2})/);
      if (!match) return null;
      let hour = Number(match[1]);
      const minute = Number(match[2]);
      return hour * 60 + minute;
    },
    isCurrentDate() {
      // 仅当所选日期是当天时才判断时间：this.currentTime 大于 offDate（截止时间）时返回 false，则对应选项不显示；其他日期不做判断
      if (!this.isToday) return true;
      const current = this.timeToMinutes(this.currentTime);
      const off = this.timeToMinutes(this.offDate);
      if (current === null || off === null) return true;
      return current <= off;
    },
    toggleStudent(student) {
      if (this.studentList.length == 1) {
        return;
      }
      const idx = this.selectedStudents.indexOf(student.child_id);
      if (idx > -1) {
        this.selectedStudents.splice(idx, 1);
      } else {
        this.selectedStudents.push(student.child_id);
      }
    },
    isSelected(student) {
      return this.selectedStudents.includes(student.child_id);
    },
    parseDateStr(dateStr) {
      const [y, m, d] = dateStr.split("-").map(Number);
      return new Date(y, m - 1, d);
    },
    onDayClick(day) {
      // 禁止选择今天以前的日期
      const clicked = new Date(day.year, day.month - 1, day.day);
      if (clicked < this.minDate) return;
      // 禁止选择周六、周日
      if (clicked.getDay() === 0 || clicked.getDay() === 6) return;
      const dateStr = `${day.year}-${String(day.month).padStart(2, "0")}-${String(day.day).padStart(2, "0")}`;
      const idx = this.addAttrsLeave.findIndex((d) => d.id === dateStr);
      if (idx >= 0) {
        this.addAttrsLeave = this.addAttrsLeave.filter((d) => d.id !== dateStr);
        this.selectedDates = this.selectedDates.filter((d) => d !== dateStr);
        this.leaveForm.dateEntries = this.leaveForm.dateEntries.filter((e) => e.date !== dateStr);
      } else {
        this.addAttrsLeave = [
          ...this.addAttrsLeave,
          {
            highlight: {
              fillMode: "solid",
              color: "white",
              style: { "background-color": "#1989FA" },
            },
            id: dateStr,
            dates: new Date(day.year, day.month - 1, day.day),
          },
        ];
        if (this.selectedDates.length === 0) {
          this.$nextTick(() => {
            const el = this.$refs.calendarWrapper;
            if (el && el.scrollIntoView) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        }
        if (!this.selectedDates.includes(dateStr)) {
          this.selectedDates = [...this.selectedDates, dateStr];
        }
        const exists = this.leaveForm.dateEntries.find((e) => e.date === dateStr);
        if (!exists) {
          const date = this.parseDateStr(dateStr);
          this.leaveForm.dateEntries = [
            ...this.leaveForm.dateEntries,
            {
              date: dateStr,
              weekday: this.weekDays[date.getDay()],
              day: [],
            },
          ];
        }
        this.sortSelectedDates();
      }
    },
    sortSelectedDates() {
      this.addAttrsLeave = [...this.addAttrsLeave].sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
      this.selectedDates = [...this.selectedDates].sort();
      this.leaveForm.dateEntries = [...this.leaveForm.dateEntries].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
    },
    removeDateEntry(idx) {
      const entry = this.leaveForm.dateEntries[idx];
      const dateStr = entry.date;
      this.addAttrsLeave = this.addAttrsLeave.filter((d) => d.id !== dateStr);
      this.selectedDates = this.selectedDates.filter((d) => d !== dateStr);
      this.leaveForm.dateEntries = this.leaveForm.dateEntries.filter((_, i) => i !== idx);
      this.selectedDate = null;
    },
    editDateEntryTime(idx) {
      const entry = this.leaveForm.dateEntries[idx];
      this.currentClickDate = entry.date;
      this.resetTimeForm();
      if (entry.day && entry.day.length == 0) {
        this.timeForm.isFullDay = true;
      }
      entry.day.forEach((tr) => {
        if (tr.day_type === 10) {
          this.timeForm.isFullDay = true;
        } else {
          this.timeForm.isFullDay = false;
        }
        if (tr.day_type === 20) {
          this.timeForm.latePickerValue = tr.day_time;
        } else if (tr.day_type === 30) {
          this.timeForm.earlyPickerValue = tr.day_time;
        } else if (tr.day_type === 40) {
          const [start, end] = tr.day_time.split("-");
          if (start && end) {
            this.timeForm.customStart = start;
            this.timeForm.customEnd = end;
          }
        }
      });
      this.refreshCurrentTime();
      this.showTimePopup = true;
    },
    toggleExpand(key) {
      // 互斥展开：点击已展开的选项则全部收起；点击未展开的选项则收起其他两个并展开它
      const willClose = this.timeForm[key];
      this.timeForm.late = false;
      this.timeForm.early = false;
      this.timeForm.customTime = false;
      if (!willClose) {
        this.refreshCurrentTime();
        this.timeForm[key] = true;
      }
    },
    resetTimeForm() {
      this.timeType = "";
      this.datetimePicker = false;
      this.timeForm = {
        isFullDay: true,
        late: false,
        latePickerValue: "",
        early: false,
        earlyPickerValue: "",
        customTime: false,
        customStart: "",
        customEnd: "",
        customPickerValues: "",
      };
    },
    clearCustomTime() {
      this.timeForm.customStart = "";
      this.timeForm.customEnd = "";
      this.timeForm.customPickerValues = "";
      this.timeForm.customTime = false;
    },
    clearLateTime() {
      this.timeForm.latePickerValue = "";
      this.timeForm.late = false;
    },
    clearEarlyTime() {
      this.timeForm.earlyPickerValue = "";
      this.timeForm.early = false;
    },
    onCustomTimeChange(picker) {
      const values = picker.getValues();
      if (values && values.length === 2) {
        let customStartHour = parseInt(values[0]);
        let customStartMin = parseInt(values[1]);
        let customStart = `${String(customStartHour).padStart(2, "0")}:${String(customStartMin).padStart(2, "0")}`;
        if (this.timeType === 1) {
          this.timeForm.customStart = customStart;
        } else if (this.timeType === 2) {
          this.timeForm.customEnd = customStart;
        }
      }
    },
    showDatetime(type) {
      this.refreshCurrentTime();
      this.timeType = type;
      this.datetimePicker = true;
    },
    confirmTime() {
      const dateStr = this.currentClickDate;
      if (!dateStr) return;

      const dates = this.parseDateStr(dateStr);
      const weekday = this.weekDays[dates.getDay()];
      const date = dateStr;
      const day = [];
      if (this.timeForm.isFullDay) {
        const dayType = this.day_types.find((d) => d.label === this.$t("leave.full_day"));
        day.push({ leave_date: dateStr, day_type: dayType ? dayType.value : 10 });
      } else {
        if (this.timeForm.latePickerValue) {
          const dayType = this.day_types.find((d) => d.label === this.$t("leave.late"));
          day.push({ leave_date: dateStr, day_type: dayType ? dayType.value : 20, day_time: `${this.timeForm.latePickerValue}` });
        }
        if (this.timeForm.earlyPickerValue) {
          const dayType = this.day_types.find((d) => d.label === this.$t("leave.early"));
          day.push({ leave_date: dateStr, day_type: dayType ? dayType.value : 30, day_time: `${this.timeForm.earlyPickerValue}` });
        }
        if (this.timeForm.customStart && this.timeForm.customEnd) {
          const dayType = this.day_types.find((d) => d.label === this.$t("leave.custom_time"));
          day.push({ leave_date: dateStr, day_type: dayType ? dayType.value : 40, day_time: `${this.timeForm.customStart} - ${this.timeForm.customEnd}` });
        }
      }

      if (day.length === 0) {
        Toast(this.$t("leave.select_time_tip"));
        return;
      }
      const idx = this.leaveForm.dateEntries.findIndex((e) => e.date === dateStr);
      const newEntry = { date, weekday, day };
      if (idx >= 0) {
        const entries = [...this.leaveForm.dateEntries];
        entries.splice(idx, 1, newEntry);
        this.leaveForm.dateEntries = entries;
      } else {
        this.leaveForm.dateEntries = [...this.leaveForm.dateEntries, newEntry];
      }
      this.sortSelectedDates();
      this.showTimePopup = false;
    },

    afterRead(file) {
      const files = Array.isArray(file) ? file : [file];
      files.forEach((item) => {
        this.uploadToQiniu(item);
      });
    },
    onOversize() {
      Toast("文件大小不能超过 50MB");
    },
    uploadToQiniu(fileItem) {
      fileItem.status = "uploading";
      fileItem.message = this.$t("pickupcard.Uploading") || "上传中";
      const config = { useCdnDomain: true, region: qiniu.region.z1 };
      const putExtra = { fname: fileItem.file.name, params: {}, mimeType: null };
      const key = fileItem.file.name;
      const observable = qiniu.upload(fileItem.file, key, this.token, putExtra, config);
      observable.subscribe({
        next: () => {},
        error: () => {
          fileItem.status = "failed";
          fileItem.message = this.$t("pickupcard.Upload_failed") || "上传失败";
          Toast(this.$t("pickupcard.Upload_failed") || "上传失败");
        },
        complete: (res) => {
          fileItem.status = "done";
          // 上传完成时如果文件已被删除，则不再加入 leaveForm.attachments
          if (this.attachments.indexOf(fileItem) === -1) return;
          const attachment = { key: res.data.key, url: res.data.url, file_name: res.data.name, file_size: res.data.size, mime_type: res.data.mimeType };
          fileItem.qiniuAttachment = attachment;
          this.leaveForm.attachments.push(attachment);
        },
      });
    },
    onDeleteFile(file) {
      // 同步移除 leaveForm.attachments 中对应的附件数据
      if (file && file.qiniuAttachment) {
        const idx = this.leaveForm.attachments.indexOf(file.qiniuAttachment);
        if (idx > -1) {
          this.leaveForm.attachments.splice(idx, 1);
        }
      }
    },
    getStudentById(id) {
      return this.studentList.find((s) => s.child_id === id) || {};
    },
    getType(type) {
      return this.typeTabs.find((t) => t.value === type)?.label || type;
    },
    verification() {
      if (this.selectedStudents.length === 0) {
        Toast(this.$t("leave.select_student_tip"));
        return;
      }
      if (this.leaveForm.type == "") {
        Toast(this.$t("leave.select_type_tip"));
        return;
      }
      if (this.leaveForm.dateEntries.length === 0) {
        Toast(this.$t("leave.select_date_tip"));
        return;
      }
      for (let i = 0; i < this.leaveForm.dateEntries.length; i++) {
        const entry = this.leaveForm.dateEntries[i];
        if (!entry.day || entry.day.length === 0) {
          Toast(this.$t("leave.select_time_tip"));
          return;
        }
      }
      if (!this.leaveForm.reason.trim()) {
        Toast(this.$t("leave.fill_reason_tip"));
        return;
      }
      this.showConfirmPopup = true;
      this.isSubmitting = false;
    },
    htmlBr(str) {
      return str.replace(/\n/g, "<br>");
    },
    submitLeave() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      createLeave({
        child_id: this.selectedStudents,
        leave_type: this.leaveForm.type,
        reason: this.leaveForm.reason,
        days: this.leaveForm.dateEntries,
        attachments: this.leaveForm.attachments,
      })
        .then((res) => {
          if (res.code == 0) {
            Toast.success(res.msg);
            router.push({
              path: "/studentLeave",
            });
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.new-leave {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 80px;

  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 10;

    .nav-icon {
      font-size: 20px;
      color: #323233;
      cursor: pointer;
    }

    .nav-title {
      font-size: 17px;
      font-weight: 600;
      color: #323233;
    }
  }
  .mt0 {
    margin-top: 0 !important;
  }
  .required {
    color: #ee0a24;
  }
  .form-section {
    background: #fff;
    padding: 16px;
    margin-top: 12px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .required-label {
        font-size: 14px;
        font-weight: 400;
        color: #323233;
      }

      .label-text {
        font-size: 15px;
        font-weight: 500;
        color: #323233;
      }

      .selected-count {
        font-size: 12px;
        color: #07c160;
      }

      .calendar-link {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        color: #1989fa;
        cursor: pointer;
      }
    }

    .student-select-list {
      .student-select-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f2f3f5;

        &:last-child {
          border-bottom: none;
        }

        .student-avatar-sm {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 12px;
        }

        .student-info {
          flex: 1;

          .student-name-sm {
            font-size: 14px;
            color: #323233;
            font-weight: 500;
          }

          .student-class-sm {
            font-size: 12px;
            color: #969799;
            margin-top: 2px;
          }
        }

        .radio-btn {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 2px solid #dcdee0;
          display: flex;
          align-items: center;
          justify-content: center;

          &.checked {
            background: #1989fa;
            border-color: #1989fa;
          }
        }
      }
    }

    .type-tabs {
      display: flex;
      gap: 12px;

      .type-tab {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        font-size: 14px;
        line-height: 14px;
        color: #646566;
        background: #f5f6f7;
        border-radius: 20px;
        cursor: pointer;

        &.active {
          color: #1989fa;
          background: #e8f3ff;
        }
      }
    }

    .calendar-wrapper {
      margin-top: 12px;
      width: 100%;
      /deep/ .vc-header {
        padding: 10px 18px;
      }
      /deep/ .is-today {
        .vc-day-content {
          color: #1989fa;
          font-weight: 500;
        }
      }
      /deep/ .vc-container {
        border: none;
        font-family: inherit;
        width: 100%;
      }

      /deep/ .vc-day-content {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 14px;
        cursor: pointer;
      }
      /deep/ .vc-day-content:hover {
        background-color: transparent;
      }
      // 周六、周日禁用样式（v-calendar 内置类：周日=weekday-1，周六=weekday-7）
      /deep/ .vc-day.weekday-1 .vc-day-content,
      /deep/ .vc-day.weekday-7 .vc-day-content {
        color: #cbd5e0 !important;
        cursor: not-allowed;
      }
      /deep/ .vc-highlight {
        border-radius: 50%;
        width: 30px;
        height: 30px;
      }
      /deep/ .vc-day-popover {
        display: none;
      }
    }

    .selected-dates {
      // margin-top: 16px;

      .selected-date-item {
        background: #f7f8fa;
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 10px;

        .date-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .date-item-title {
            font-size: 14px;
            font-weight: 500;
            color: #323233;
          }

          .van-icon {
            cursor: pointer;
          }
        }

        .time-ranges {
          display: flex;
          align-items: center;
          .arrow-icon {
            font-size: 14px;
            margin-top: 2px;
          }
          .time-range-row {
            flex: 1;
            text-align: right;
            font-size: 14px;
            padding-right: 8px;
            cursor: pointer;
            .colorC {
              color: #c8c9cc;
              line-height: 14px;
            }

            .time-range-label {
              min-width: 50px;
              flex: 1;
            }
            .period {
              color: #1989fa;
            }
            .time-range-value {
              color: #646566;
              margin-left: 8px;
            }
          }
        }
      }
    }

    .reason-input {
      width: 100%;
      border: 1px solid #ebedf0;
      border-radius: 8px;
      padding: 12px;
      font-size: 14px;
      color: #323233;
      resize: none;
      box-sizing: border-box;
      outline: none;

      &::placeholder {
        color: #c8c9cc;
      }
    }

    .attachment-area {
      /deep/ .van-uploader__preview-image {
        border-radius: 8px;
      }
    }
  }

  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    z-index: 10;

    .btn-submit {
      text-align: center;
      padding: 12px 0;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background: #1989fa;
      border-radius: 24px;
      cursor: pointer;
    }
  }

  // // 弹窗样式
  .time-popup,
  .schedule-popup,
  .confirm-popup {
    padding: 16px;
    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // padding-bottom: 16px;
      // margin-bottom: 16px;

      .popup-title {
        font-size: 16px;
        font-weight: 500;
        color: #323233;
        flex: 1;
        text-align: center;
      }

      .van-icon {
        font-size: 20px;
        color: #969799;
        cursor: pointer;
      }
    }

    .popup-actions {
      display: flex;
      gap: 12px;
      margin-top: 20px;

      .btn-cancel,
      .btn-confirm {
        flex: 1;
        text-align: center;
        padding: 10px 0;
        font-size: 15px;
        border-radius: 20px;
        cursor: pointer;
      }

      .btn-cancel {
        color: #646566;
        background: #fff;
        border: 1px solid #ebedf0;
      }

      .btn-confirm {
        color: #fff;
        background: #1989fa;

        &.is-disabled {
          opacity: 0.6;
          pointer-events: none;
        }
      }
    }
  }

  // 选择时间弹窗
  .time-popup-popup {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .time-popup {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;

      .popup-header {
        flex-shrink: 0;
        padding-bottom: 16px;
      }

      .time-popup-body {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      .popup-actions {
        flex-shrink: 0;
      }

      .time-type-row {
        display: flex;
        gap: 24px;
        margin: 16px 0 16px;

        .radio-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #323233;
          cursor: pointer;

          .radio-circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid #dcdee0;
            display: flex;
            align-items: center;
            justify-content: center;

            &.checked {
              background: #1989fa;
              border-color: #1989fa;
            }
          }
        }
      }

      .partial-options {
        .option-row {
          display: flex;
          align-items: center;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 8px;
          cursor: pointer;
          transition: background 0.2s;

          &.is-selected {
            background: #e8f3ff;
          }

          .option-label {
            font-weight: 500;
            font-size: 14px;
            color: #323233;
          }

          .option-value {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 8px;
            font-size: 14px;
            line-height: 14px;
            color: #1989fa;
          }

          .option-placeholder {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 6px;
            font-size: 14px;
            color: #c8c9cc;
          }
        }
        .option-active {
          background: #e8f3ff !important;
          border: 1px solid rgba(25, 137, 250, 0.3) !important;
        }
        .custom-time-row {
          flex-direction: column;
          align-items: stretch;
          padding: 0;
          margin-bottom: 8px;
          background: transparent;
          border: 1px solid #ebedf0;
          border-radius: 8px;

          &.expanded,
          &.has-value {
            background: transparent;
            border-color: #1989fa;
          }

          .option-header {
            display: flex;
            align-items: center;
            // width: 100%;
            padding: 12px;
            line-height: 1;
            border-radius: 8px;
            .is-expanded {
              transform: rotate(180deg);
              transition: transform 0.2s;
            }
          }
        }

        // 晚到/早退/自定义内联选择器
        .late-time-row,
        .early-time-row,
        .custom-time-row {
          flex-direction: column;
          align-items: stretch;
          padding: 0;
          margin-bottom: 8px;
          border: 1px solid #ebedf0;
          border-radius: 8px;

          &.expanded,
          &.has-value {
            background: transparent;
            border-color: #1989fa;
          }

          .option-header {
            display: flex;
            align-items: center;
            // width: 100%;
            padding: 12px;
            border-radius: 8px;
            .is-expanded {
              transform: rotate(180deg);
              transition: transform 0.2s;
            }
          }

          .inline-time-picker {
            // margin-top: 8px;
            padding: 0 12px 12px;
            background: #fff;
            border-radius: 0 0 8px 8px;

            .inline-picker {
              /deep/ .van-picker__toolbar {
                display: none;
              }

              /deep/ .van-picker-column__item {
                font-size: 14px;
              }
            }
          }

          .custom-time-picker {
            padding: 8px 12px 12px;
            border-radius: 0 0 8px 8px;
            background: #fff;
            .custom-time-display-row {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 12px;
              margin-bottom: 8px;

              .custom-time-box {
                flex: 1;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                font-size: 14px;
                background: #f2f3f5;
                border: 1px solid #ebedf0;
                .placeholder {
                  color: #c8c9cc;
                }
                &.start {
                  background: #ecf5ff;
                  border: 1px solid #1989fa;

                  .time-text {
                    color: #1989fa;
                  }
                }

                &.end {
                  background: #f2f3f5;
                  border: 1px solid #ebedf0;

                  .time-text {
                    color: #c8c9cc;

                    &.placeholder {
                      color: #c8c9cc;
                    }
                  }
                }
              }

              .time-separator {
                font-size: 16px;
                color: #969799;
              }
            }

            .time-picker-wrapper {
              .inline-picker {
                /deep/ .van-picker__toolbar {
                  display: none;
                }

                /deep/ .van-picker-column__item {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }

  // 时间表弹窗
  .schedule-popup {
    .schedule-list {
      margin-top: 16px;
      .schedule-item {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #f2f3f5;

        &:last-child {
          border-bottom: none;
        }

        .schedule-id {
          font-size: 14px;
          color: #323233;
        }

        .schedule-time {
          font-size: 14px;
          color: #646566;
        }
      }
    }
  }

  // 确认弹窗
  .confirm-popup {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    padding: 0 16px;
    .popup-header {
      flex-shrink: 0;
      padding-bottom: 16px;
      margin-top: 16px;
    }

    .confirm-content {
      flex: 1;
      min-height: 0;
      margin-top: 0;
      overflow-y: auto;
      background: #f7f8fa;
      border-radius: 12px;
      padding: 16px 20px;
      .confirm-students {
        .confirm-student {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;

          &:last-child {
            margin-bottom: 0;
          }

          .confirm-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }

          .confirm-name {
            font-size: 14px;
            color: #323233;
          }

          .confirm-class {
            font-size: 12px;
            color: #969799;
          }
        }
      }
      .confirm-row {
        display: flex;
        padding-top: 16px;

        &:last-child {
          border-bottom: none;
        }

        .confirm-label {
          min-width: 80px;
          font-size: 14px;
          color: #969799;
        }

        .confirm-value {
          flex: 1;
          font-size: 14px;
          color: #323233;
          font-weight: 400;
        }

        .confirm-reason {
          line-height: 1.5;
        }

        .confirm-dates {
          flex: 1;

          .confirm-date-item {
            padding: 6px 0;
            border-bottom: 1px solid #dcdee0;
            &:last-child {
              margin-bottom: 0;
            }

            .confirm-date-title {
              font-size: 14px;
              font-weight: 500;
              color: #323233;
              margin-bottom: 4px;
            }

            .confirm-date-times {
              font-size: 12px;
              color: #646566;
              line-height: 1.6;
            }
          }
        }

        .confirm-attachments {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          .confirm-attachment-img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 6px;
          }
        }
      }
    }

    .popup-actions {
      margin: 12px 0;
    }
  }
}
</style>
